(function () {
  const initProductAccordion = () => {
    document.querySelectorAll(".about__accordion-toggle").forEach((toggle) => {
      toggle.addEventListener("click", (event) => {
        event.preventDefault();
        const description = toggle.nextElementSibling?.classList.contains("about__accordion-description")
          ? toggle.nextElementSibling
          : toggle.previousElementSibling?.classList.contains("about__accordion-description")
          ? toggle.previousElementSibling
          : null;
        if (description) {
          toggle.classList.contains("active") ? slideUp(toggle, description, 300) : slideDown(toggle, description, 300);
        }
      });
    });
  };

  let countdownInterval;
  const removeProductCountdown = () => clearInterval(countdownInterval);
  const formatTime = (time) => (time < 10 ? `0${time}` : time);

  const initProductCountdown = () => {
    const countDownWrapper = document.querySelector(".product-countdown");
    if (!countDownWrapper) return;
    const userDate = countDownWrapper.getAttribute("data-date");
    const userTime = countDownWrapper.getAttribute("data-time");
    if (!userDate || !userTime) return;
    removeProductCountdown();
    countdownInterval = setInterval(() => updateTimer(countDownWrapper, userDate, userTime), 1000);
    updateTimer(countDownWrapper, userDate, userTime);
  };

  const updateTimer = (wrapper, userDate, userTime) => {
    const countdownDate = new Date(`${userDate}T${userTime}`);
    const distance = countdownDate - new Date();
    if (distance < 0) {
      removeProductCountdown();
      handleCountdownEnd(wrapper, wrapper.querySelector(".product-countdown__main"), wrapper.querySelector(".product-countdown__end-info"), wrapper.getAttribute("data-completed"), wrapper.querySelector(".product-countdown__promo"));
    } else {
      displayTime(wrapper, distance);
    }
  };

  const handleCountdownEnd = (wrapper, countdown, countdownHeading, completedCountdown, countdownPromo) => {
    if (completedCountdown === "hide_section") {
      wrapper.style.display = "none";
    } else if (completedCountdown === "show_text") {
      countdown.style.display = "none";
      if (countdownPromo) countdownPromo.style.display = "none";
      if (countdownHeading) countdownHeading.style.display = "flex";
    }
  };

  const displayTime = (wrapper, distance) => {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    wrapper.querySelector(".product-countdown_block_days").textContent = formatTime(days);
    wrapper.querySelector(".product-countdown_block_hours").textContent = formatTime(hours);
    wrapper.querySelector(".product-countdown_block_minutes").textContent = formatTime(minutes);
    wrapper.querySelector(".product-countdown_block_seconds").textContent = formatTime(seconds);
  };

  const revealPopup = (section) => {
    if (!section?.classList.contains("product-section")) return;
    const buyButtons = section.querySelector(".product__buy-buttons > product-form");
    const stickyBar = document.querySelector(".product-countdown");
    const footerBottom = document.querySelector(".shopify-section-group-footer-group .footer-bottom");
    if (!stickyBar) return;
    const toggleStickyBar = (isVisible) => {
      if (isVisible || (buyButtons?.getBoundingClientRect().top > 0)) {
        stickyBar.classList.remove("active");
        removeProductCountdown();
      } else {
        stickyBar.classList.add("active");
        initProductCountdown();
      }
    };
    const observer = new IntersectionObserver((entries) => toggleStickyBar(entries.some((entry) => entry.isIntersecting)), { root: null, rootMargin: "0px", threshold: 0.01 });
    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  function setSelectedVariant(variantId) {
    if (!variantId) return;
    
    document.querySelectorAll('label.color-swatch').forEach(el => {
      el.classList.remove('variant-selected');
    });

    const target = document.querySelector(`input[type="radio"][data-variant-id="${variantId}"]`);
    if (target) {
      const labelByFor = target.id && document.querySelector(`label[for="${target.id}"]`);
      const wrappingLabel = target.closest('label');
      const label = labelByFor || wrappingLabel;

      if (label && label.classList.contains('color-swatch')) {
        label.classList.add('variant-selected');
      }
    }
  }

  function initVariantSelection() {
    // Set initial selected variant from URL or checked input
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant');
    
    if (urlVariantId) {
      setSelectedVariant(urlVariantId);
    } else {
      // Find the checked input with data-variant-id
      const checkedInput = document.querySelector('input[type="radio"][data-variant-id]:checked');
      if (checkedInput) {
        const variantId = checkedInput.getAttribute('data-variant-id') || checkedInput.dataset.variantId;
        if (variantId) {
          setSelectedVariant(variantId);
        }
      }
    }

    // Listen to input change events for variant selection
    const handleVariantSelectionChange = (e) => {
      const input = e.target;
      if (input.matches('input[type="radio"][data-variant-id]') && input.checked) {
        const variantId = input.getAttribute('data-variant-id') || input.dataset.variantId;
        if (variantId) {
          setSelectedVariant(variantId);
        }
      }
    };
    document.addEventListener('change', handleVariantSelectionChange);

    // Also listen to label clicks as fallback
    document.addEventListener('click', (e) => {
      const label = e.target.closest('label.color-swatch');
      if (!label) return;
      const inputId = label.getAttribute('for');
      if (!inputId) return;
      const input = document.getElementById(inputId);
      if (input && input.matches('input[type="radio"][data-variant-id]')) {
        // Use setTimeout to ensure the input is checked after the click
        setTimeout(() => {
          if (input.checked) {
            const variantId = input.getAttribute('data-variant-id') || input.dataset.variantId;
            if (variantId) {
              setSelectedVariant(variantId);
            }
          }
        }, 0);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantSelection);
  } else {
    initVariantSelection();
  }

  const initProductToggle = () => {
    const toggleSection = document.querySelector('.product__toggle-section');
    if (!toggleSection) return;
    const toggleButtons = Array.from(toggleSection.querySelectorAll('.product__toggle-btn'));
    const slider = toggleSection.querySelector('.product__toggle-slider');
    if (!toggleButtons.length || !slider) return;
    const productRoot = toggleSection.closest('.product') || document;
    const mediaList = productRoot.querySelector('.js-media-list');
    const mediaSublist = productRoot.querySelector('.js-media-sublist');

    const waitForElement = (selector, { root = document, timeout = 3000, interval = 100 } = {}) =>
      new Promise((resolve, reject) => {
        const start = Date.now();
        const attempt = () => {
          const element = root.querySelector(selector);
          if (element) return resolve(element);
          if (Date.now() - start >= timeout) return reject(new Error(`Timeout waiting for ${selector}`));
          setTimeout(attempt, interval);
        };
        attempt();
      });

    let glbModel = productRoot.querySelector('.product__media-glb');
    let glbModelPromise;
    const getGlbModel = async () => {
      if (glbModel) return glbModel;
      if (!glbModelPromise) {
        glbModelPromise = waitForElement('.product__media-glb', { root: productRoot, timeout: 2000, interval: 100 })
          .then((element) => (glbModel = element))
          .catch(() => null);
      }
      return glbModelPromise;
    };

    const updateSliderPosition = (activeButton) => {
      const buttonRect = activeButton.getBoundingClientRect();
      const containerRect = activeButton.parentElement.getBoundingClientRect();
      slider.style.width = `${buttonRect.width}px`;
      slider.style.transform = `translateX(${buttonRect.left - containerRect.left - 4}px)`;
    };

    const setActiveButtonState = (activeButton) => {
      toggleButtons.forEach((btn) => {
        btn.classList.toggle('active', btn === activeButton);
        btn.setAttribute('aria-pressed', String(btn === activeButton));
      });
      updateSliderPosition(activeButton);
    };

    const updateSwiperSlides = (viewMode) => {
      if (mediaList?.swiper) {
        const swiper = mediaList.swiper;
        const slides = Array.from(swiper.slides || []);
        const isPhotosMode = viewMode === 'photos';
        slides.forEach(slide => {
          const shouldHide = isPhotosMode && slide.classList.contains('product__media-item--3d');
          slide.style.display = shouldHide ? 'none' : '';
          slide.classList.toggle('swiper-slide-hidden', shouldHide);
        });
        if (isPhotosMode && slides[swiper.activeIndex]?.classList.contains('product__media-item--3d')) {
          const firstPhotoIndex = slides.findIndex(s => !s.classList.contains('product__media-item--3d'));
          if (firstPhotoIndex !== -1) swiper.slideTo(firstPhotoIndex, 0);
        }
        swiper.update();
      }
      mediaSublist?.swiper?.update();
    };

    const ensureModelViewerPlaying = async (glb) => {
      if (!glb) return;
      const allModels = glb.querySelectorAll('.product-media-modal__model');
      let visibleModel = Array.from(allModels).find(m => !m.hidden && !m.classList.contains('is-hidden')) || allModels[0];
      if (!visibleModel) return;
      visibleModel.classList.add('is-visible', 'is-active');
      visibleModel.classList.remove('is-hidden', 'is-fading-out', 'is-fading-in');
      visibleModel.hidden = false;
      const deferredMedia = visibleModel.querySelector('product-model.deferred-media');
      if (deferredMedia?.loadContent && !deferredMedia.hasAttribute('data-loaded')) {
        deferredMedia.loadContent();
        deferredMedia.setAttribute('data-loaded', 'true');
      }
      let modelViewer = visibleModel.querySelector('model-viewer');
      if (!modelViewer && deferredMedia) {
        await new Promise(resolve => setTimeout(resolve, 200));
        modelViewer = visibleModel.querySelector('model-viewer');
      }
      if (modelViewer) {
        const isMobile = window.innerWidth < 750;
        modelViewer.classList.toggle('shopify-model-viewer-ui__disabled', isMobile);
        modelViewer.setAttribute('tabindex', isMobile ? '-1' : '0');
      }
    };

    const apply360Layout = async (glb) => {
      if (!glb) return;
      if (mediaList) {
        mediaList.classList.add('is-fading-out');
        setTimeout(() => {
          mediaList.querySelectorAll('.product__media-item:not(.product__media-subitem)').forEach(item => item.classList.add('is-hidden'));
          mediaList.classList.remove('is-fading-out');
          mediaList.classList.add('is-fading-in');
        }, 300);
        if (mediaSublist) {
          mediaSublist.classList.add('is-visible');
          mediaSublist.querySelectorAll('.product__media-subitem').forEach(subitem => subitem.classList.remove('is-hidden'));
        }
      }
      glb.classList.remove('is-hidden');
      glb.classList.add('is-visible');
      glb.classList.remove('is-active');
      requestAnimationFrame(() => glb.classList.add('is-active'));
      glb.querySelectorAll('.product-media-modal__model:not([hidden])').forEach(model => {
        model.classList.remove('is-hidden');
        model.classList.add('is-visible', 'is-fading-in');
        requestAnimationFrame(() => {
          model.classList.remove('is-fading-in');
          model.classList.add('is-active');
        });
      });
      const isMobile = window.innerWidth < 750;
      glb.querySelectorAll('model-viewer').forEach(el => {
        if (!isMobile) {
          el.classList.remove('shopify-model-viewer-ui__disabled');
          el.setAttribute('tabindex', '0');
        }
      });
      await ensureModelViewerPlaying(glb);
    };

    const applyPhotosLayout = (glb) => {
      if (glb) {
        glb.classList.remove('is-active');
        setTimeout(() => {
          glb.classList.remove('is-visible');
          glb.classList.add('is-hidden');
        }, 300);
      }
      if (mediaList) {
        mediaList.classList.add('is-fading-in');
        mediaList.querySelectorAll('.product__media-item').forEach(item => item.classList.remove('is-hidden'));
      }
    };

    const applyViewMode = async (viewMode) => {
      toggleSection.setAttribute('data-view-mode', viewMode);
      const glb = await getGlbModel();
      if (viewMode === '360') {
        await apply360Layout(glb);
      } else {
        applyPhotosLayout(glb);
      }
      updateSwiperSlides(viewMode);
    };

    const handleButtonClick = (button) => {
      const viewMode = button.getAttribute('data-toggle-btn') === '1' ? '360' : 'photos';
      setActiveButtonState(button);
      applyViewMode(viewMode);
    };

    toggleButtons.forEach((button) => button.addEventListener('click', () => handleButtonClick(button)));
    toggleButtons.forEach((button, index) => {
      button.addEventListener('keydown', (e) => {
        const isNext = ['ArrowDown', 'ArrowRight'].includes(e.key);
        const isPrev = ['ArrowUp', 'ArrowLeft'].includes(e.key);
        if (!isNext && !isPrev) return;
        e.preventDefault();
        const nextIndex = (index + (isNext ? 1 : -1) + toggleButtons.length) % toggleButtons.length;
        toggleButtons[nextIndex].focus();
        toggleButtons[nextIndex].click();
      });
    });

    let resizeFrame = null;
    window.addEventListener('resize', () => {
      if (resizeFrame) return;
      resizeFrame = requestAnimationFrame(() => {
        const activeButton = toggleSection.querySelector('.product__toggle-btn.active');
        if (activeButton) updateSliderPosition(activeButton);
        resizeFrame = null;
      });
    });

    const sidebarSelector = '.js-media-subitem, .product__media-subitem';
    const sidebarClickHandler = (event) => {
      if (!event.target.closest(sidebarSelector) || toggleSection.getAttribute('data-view-mode') === 'photos') return;
      const photosButton = toggleButtons.find((btn) => btn.getAttribute('data-toggle-btn') === '2');
      photosButton ? photosButton.click() : applyViewMode('photos');
    };

    const sidebarContainer = mediaSublist || productRoot;
    if (!sidebarContainer.__productSidebarToggleHandlerAttached) {
      sidebarContainer.addEventListener('click', sidebarClickHandler);
      sidebarContainer.__productSidebarToggleHandlerAttached = true;
    }

    const initialButton = toggleSection.querySelector('.product__toggle-btn.active') || toggleSection.querySelector('.product__toggle-btn[data-toggle-btn="2"]') || toggleButtons[0];
    if (initialButton) {
      slider.style.transition = 'none';
      setActiveButtonState(initialButton);
      applyViewMode(initialButton.getAttribute('data-toggle-btn') === '1' ? '360' : 'photos');
      requestAnimationFrame(() => slider.style.transition = '');
    }

    const ensureInitialPlayback = () => {
      getGlbModel().then(glb => {
        if (glb) ensureModelViewerPlaying(glb).then(() => initialPlaybackObserver.disconnect()).catch(() => {});
      });
    };

    const initialPlaybackObserver = new MutationObserver(ensureInitialPlayback);
    initialPlaybackObserver.observe(productRoot, { childList: true, subtree: true });
    ensureInitialPlayback();

    const preloaded360Button = toggleSection.querySelector('.product__toggle-btn[data-toggle-btn="1"]');
    if (preloaded360Button && initialButton !== preloaded360Button) {
      getGlbModel().then(glb => glb && ensureModelViewerPlaying(glb));
    }
  };

  const initModelViewerScrollLock = () => {
    const productMediaWrapper = document.querySelector('.product__media-wrapper');
    if (!productMediaWrapper) return;
    const setupModelViewer = (modelViewer) => {
      if (modelViewer.hasAttribute('data-scroll-lock-setup')) return;
      modelViewer.setAttribute('data-scroll-lock-setup', 'true');
      modelViewer.addEventListener('mouseenter', () => modelViewer.dataset.isOver = 'true');
      modelViewer.addEventListener('mouseleave', () => modelViewer.dataset.isOver = 'false');
      modelViewer.addEventListener('wheel', (e) => e.stopPropagation(), { passive: true });
      modelViewer.addEventListener('touchmove', (e) => e.stopPropagation(), { passive: true });
    };
    document.querySelectorAll('model-viewer').forEach(setupModelViewer);
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === 'MODEL-VIEWER') {
            setupModelViewer(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('model-viewer').forEach(setupModelViewer);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  document.addEventListener("shopify:section:load", (event) => {
    initProductAccordion();
    initProductToggle();
    initModelViewerScrollLock();
    revealPopup(event.target);
  });

  initProductAccordion();
  initProductToggle();
  initModelViewerScrollLock();
  revealPopup(document.currentScript.parentElement);
})();

(() => {
  const showFirstModel = () => {
    document.querySelectorAll('.product-media-modal__model').forEach((el, index) => {
      el.hidden = index !== 0;
      el.style.display = index === 0 ? '' : 'none';
    });
  };

  const updateModelVisibility = (variantId, forceReload = false) => {
    if (!variantId) {
      showFirstModel();
      return;
    }
    const variantIdStr = String(variantId);
    let visibleModel = null;
    const glb = document.querySelector('.product__media-glb');
    const is360Active = glb?.classList.contains('is-visible');
    if (is360Active && forceReload) {
      document.querySelectorAll('.product-media-modal__model:not([hidden])').forEach((el) => {
        el.classList.add('is-fading-out');
        el.classList.remove('is-active');
      });
    }
    document.querySelectorAll('.product-media-modal__model').forEach((el) => {
      if (el.dataset.variantId === variantIdStr) {
        visibleModel = el;
      } else {
        el.hidden = true;
        el.classList.add('is-hidden');
        el.classList.remove('is-visible', 'is-active', 'is-fading-in', 'is-fading-out');
      }
    });
    if (!visibleModel) {
      showFirstModel();
      visibleModel = document.querySelector('.product-media-modal__model');
    }
    if (visibleModel) {
      visibleModel.hidden = false;
      visibleModel.classList.remove('is-hidden', 'is-fading-out');
      visibleModel.classList.add('is-visible');
      if (is360Active && forceReload) {
        visibleModel.classList.add('is-fading-in');
        visibleModel.classList.remove('is-active');
        const deferredMedia = visibleModel.querySelector('product-model.deferred-media');
        if (deferredMedia?.loadContent && !deferredMedia.hasAttribute('data-loaded')) {
          deferredMedia.loadContent();
          deferredMedia.setAttribute('data-loaded', 'true');
        }
        const modelViewer = visibleModel.querySelector('model-viewer');
        if (modelViewer && window.innerWidth >= 750) {
          modelViewer.classList.remove('shopify-model-viewer-ui__disabled');
          modelViewer.setAttribute('tabindex', '0');
        }
        setTimeout(() => {
          requestAnimationFrame(() => {
            visibleModel.classList.remove('is-fading-in');
            visibleModel.classList.add('is-active');
          });
        }, 100);
      } else {
        visibleModel.classList.add('is-active');
      }
    }
  };

  const getCurrentVariantId = () => {
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    if (urlVariant) return urlVariant;
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput?.value) return variantInput.value;
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects?.currentVariant?.id) return variantSelects.currentVariant.id;
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios?.currentVariant?.id) return variantRadios.currentVariant.id;
    const fieldsets = document.querySelectorAll('variant-radios fieldset, variant-selects fieldset');
    if (fieldsets.length > 0) {
      const selectedOptions = Array.from(fieldsets).map(fs => fs.querySelector('input:checked')?.value).filter(Boolean);
      if (selectedOptions.length > 0) {
        const variantDataScript = document.querySelector('variant-radios [type="application/json"], variant-selects [type="application/json"]');
        if (variantDataScript) {
          try {
            const variantData = JSON.parse(variantDataScript.textContent);
            const matchingVariant = variantData.find(v => v.options.every((opt, i) => selectedOptions[i] === opt));
            if (matchingVariant?.id) return matchingVariant.id;
          } catch (e) {}
        }
      }
    }
    const checkedRadio = document.querySelector('input[type="radio"][data-variant-id]:checked');
    if (checkedRadio?.dataset.variantId) return checkedRadio.dataset.variantId;
    const variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect?.value) return variantSelect.value;
    return null;
  };

  const ensureDefaultVariantChecked = () => {
    if (document.querySelector('input[type="radio"][name*="option"]:checked, input[type="radio"][name*="Option"]:checked')) return;
    document.querySelectorAll('variant-radios, variant-selects').forEach(container => {
      container.querySelectorAll('fieldset').forEach(fieldset => {
        if (!fieldset.querySelector('input:checked')) {
          const firstInput = fieldset.querySelector('input[type="radio"]:not(.disabled)');
          if (firstInput) firstInput.checked = true;
        }
      });
    });
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios?.onVariantChange) variantRadios.onVariantChange();
  };

  const initModelVisibility = () => {
    ensureDefaultVariantChecked();
    const variantId = getCurrentVariantId();
    updateModelVisibility(variantId);
  };

  const is360Mode = () => document.querySelector('.product__toggle-section')?.getAttribute('data-view-mode') === '360';
  const handleVariantChange = () => {
    setTimeout(() => {
      const variantId = getCurrentVariantId();
      if (variantId) updateModelVisibility(variantId, is360Mode());
    }, 50);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initModelVisibility();
      setTimeout(initModelVisibility, 300);
    });
  } else {
    initModelVisibility();
    setTimeout(initModelVisibility, 200);
    setTimeout(initModelVisibility, 500);
  }

  document.addEventListener('variant:changed', (e) => {
    const variantId = e.detail?.variant?.id;
    if (variantId) updateModelVisibility(variantId, is360Mode());
  });

  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('input[type="radio"][data-variant-id]')) {
      if (target.dataset.variantId) updateModelVisibility(target.dataset.variantId, is360Mode());
    } else if (target.matches('input[type="radio"][name*="option"], input[type="radio"][name*="Option"], input[name="id"]')) {
      handleVariantChange();
    }
  });

  document.querySelectorAll('variant-radios, variant-selects').forEach(container => {
    if (container.__modelListener) container.removeEventListener('change', container.__modelListener);
    container.__modelListener = handleVariantChange;
    container.addEventListener('change', container.__modelListener);
  });
})();
